import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';
import { NewLotResponse } from '../components/bids-and-offers/lots.model';

@Injectable({
  providedIn: 'root',
})
export class NewLotOptionsService extends Query<NewLotResponse> {
  document = gql`
    query LotCreationFieldsQuery($market: Market!) {
      origins(market_type: $market) {
        _id
        name
      }
      commodities(market_type: $market) {
        _id
        commodity
        origin
        order
        basis_product_code
        price_types
        product_types {
          product_type
          grades_conditions {
            grade
            specifications {
              title
              order
              defaultValue
              isRequired
              type
            }
            # grade_delivery_types
          }
        }
      }
      deliveryTypes(market_type: $market) {
        _id
        name
        payment_terms
        container_types
        delivery_options
        currencies
        packaging_types
        tolerances
        weight_grade_to_govern
        rules_to_govern
        market_type
        price_units
        documentations {
          title
          type
          order
          defaultValue
          options
          isRequired
        }
      }
      units {
        _id
        name
        name_slug
        name_short
      }
    }
  `;
}
